import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject,
  input,
} from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatToolbar } from '@angular/material/toolbar';
import {
  MatSidenavContainer,
  MatSidenavContent,
} from '@angular/material/sidenav';

@Component({
  selector: 'lib-layout',
  standalone: true,
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatToolbar, MatSidenavContainer, MatSidenavContent],
  host: {
    '[class.example-is-mobile]': 'mobileQuery.matches',
  },
})
export class LayoutComponent implements OnDestroy {
  readonly showBackground = input<boolean>(true);

  private changeDetectorRef = inject(ChangeDetectorRef);
  private media = inject(MediaMatcher);

  protected mobileQuery: MediaQueryList =
    this.media.matchMedia('(max-width: 600px)');
  private mobileQueryListener = () => this.changeDetectorRef.markForCheck();

  constructor() {
    this.mobileQuery.addEventListener('change', this.mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
  }
}
